var map = {
	"./changemode.png": 2917,
	"./cs.png": 2207,
	"./csm.png": 8205,
	"./de.png": 2470,
	"./dem.png": 853,
	"./eng.png": 9698,
	"./engm.png": 4398,
	"./flatlogowhite.png": 1876,
	"./logo.png": 6338,
	"./logoDark.png": 3499,
	"./logomobile.png": 8629,
	"./logomobilewhite.png": 6272,
	"./pl.png": 607,
	"./plm.png": 9636,
	"./prem.png": 1232,
	"./ru.png": 5821,
	"./rum.png": 4898,
	"./sierzant_down.png": 5246,
	"./sierzant_up.png": 5431,
	"./sk.png": 2749,
	"./skm.png": 5249,
	"./unknown.png": 1944,
	"./unknownm.png": 1689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;